import CloseIcon from '@mui/icons-material/Close'
import { FC } from 'react'
import { FloatingActionButtons } from './FloatingActionButtons'

interface CancelEditButtonProps {
  onCancel: () => void
}

export const CancelEditButton: FC<CancelEditButtonProps> = ({ onCancel }) => {
  return (
    <FloatingActionButtons.Button color="error" title="Cancelar dibujo (ESC)" onClick={onCancel}>
      <CloseIcon />
    </FloatingActionButtons.Button>
  )
}
